export const EMPTY_ERR = 'Enter a CIDR range or interface name';
export const DUPLICATE_ERR = 'This CIDR or interface is already in the list';

/**
 * Build a validator function for a CIDR IP _OR_ interface name string.  Optional parameters are used to look
 * for duplicate values that have already been saved
 *
 * @param names     CIDRs and interface names that have already been added to the list
 * @param currIndex If editing, the index of the item being edited.  That's fine to match existing names.
 * @returns
 */
export function makeUniqueNameRequiredValidator(names: string[] = [], currIndex?: number) {
  return function validateUniqueName(value?: string): string | true {
    if (!value?.trim()) return EMPTY_ERR;

    // If the name already exists, and it's not the one we're editing
    const matchingIndex = names.indexOf(value);
    if (matchingIndex !== -1 && matchingIndex !== currIndex) {
      return DUPLICATE_ERR;
    }

    return true;
  };
}
